import { profiles } from "../misc/Static";

function calcData(match, pOrder, pid, queues) {
  if (!match) return false;
  const mmrscore = {
    UNRANKED: 0,
    IRON: 0,
    BRONZE: 400,
    SILVER: 800,
    GOLD: 1200,
    PLATINUM: 1600,
    EMERALD: 2000,
    DIAMOND: 2400,
    MASTER: 2800,
    GRANDMASTER: 2800,
    CHALLENGER: 2800,
    "": 0,
    IV: 0,
    III: 100,
    II: 200,
    I: 300,
  };
  const divisions = ["IV", "III", "II", "I"];
  let score;
  let teamKills = [0, 0];
  let rankedPlayers = 0;
  let mmrTotal = 0;
  pOrder.forEach((team, i) =>
    team.forEach((p, j) => {
      teamKills[i] += match.kills[p];
    })
  );
  let calc = {
    tower: [],
    inhib: [],
    herald: [],
    dragon: [],
    baron: [],
    kills: [0, 0],
    deaths: [0, 0],
    assists: [0, 0],
    kda: [],
    kp: [],
    multi: [],
    totalMinions: [],
    maxDamage: 0,
  };
  pOrder.forEach((team, i) => {
    calc.tower[i] = match.tower ? [team[0]] : 0;
    calc.inhib[i] = match.tower ? match.inhib[team[0]] : 0;
    calc.herald[i] = match.tower ? match.herald[team[0]] : 0;
    calc.dragon[i] = match.tower ? match.dragon[team[0]] : 0;
    calc.baron[i] = match.tower ? match.barons[team[0]] : 0;
  });
  pOrder.forEach((team, i) =>
    team.forEach((p, j) => {
      if (match.totalDamageDealtToChampions[p] > calc.maxDamage)
        calc.maxDamage = match.totalDamageDealtToChampions[p];
      calc.kills[i] += match.kills[p];
      calc.deaths[i] += match.deaths[p];
      calc.assists[i] += match.assists[p];
      calc.totalMinions[p] = match.neutralMinionsKilled
        ? match.neutralMinionsKilled[p] + match.totalMinionsKilled[p]
        : 0;
      calc.kda[p] =
        match.deaths[p] > 0
          ? (
              Math.round(
                ((match.kills[p] + match.assists[p]) / match.deaths[p]) * 10
              ) / 10
            ).toFixed(1)
          : "PERFECT";
      calc.kp[p] =
        teamKills[i] > 0
          ? Math.round(
              ((match.kills[p] + match.assists[p]) / teamKills[i]) * 100
            )
          : 0;
      calc.multi[p] = match.doubleKills[p] ? "Double" : "";
      if (match.tripleKills && match.tripleKills[p]) calc.multi[p] = "Triple";
      if (match.tripleKills && match.quadraKills[p]) calc.multi[p] = "Quadra";
      if (match.tripleKills && match.pentaKills[p]) calc.multi[p] = "Penta";
      score =
        mmrscore[match.tier[p]] + mmrscore[[match.division[p]]] + match.lp[p];
      if (score) {
        mmrTotal += score;
        rankedPlayers++;
      }
    })
  );

  const mmmr = rankedPlayers > 4 ? Math.round(mmrTotal / rankedPlayers) : 0;
  let mmmrTier, mmmrDivision, mmmrLP;
  if (mmmr === 0) {
    mmmrTier = "";
    mmmrDivision = "";
    mmmrLP = "";
  } else if (mmmr < 400) {
    mmmrTier = "Iron";
    mmmrDivision = divisions[parseInt(mmmr / 100)];
    mmmrLP = mmmr - parseInt(mmmr / 100) * 100;
  } else if (mmmr < 800) {
    mmmrTier = "Bronze";
    mmmrDivision = divisions[parseInt((mmmr - 400) / 100)];
    mmmrLP = mmmr - 400 - parseInt((mmmr - 400) / 100) * 100;
  } else if (mmmr < 1200) {
    mmmrTier = "Silver";
    mmmrDivision = divisions[parseInt((mmmr - 800) / 100)];
    mmmrLP = mmmr - 800 - parseInt((mmmr - 800) / 100) * 100;
  } else if (mmmr < 1600) {
    mmmrTier = "Gold";
    mmmrDivision = divisions[parseInt((mmmr - 1200) / 100)];
    mmmrLP = mmmr - 1200 - parseInt((mmmr - 1200) / 100) * 100;
  } else if (mmmr < 2000) {
    mmmrTier = "Platinum";
    mmmrDivision = divisions[parseInt((mmmr - 1600) / 100)];
    mmmrLP = mmmr - 1600 - parseInt((mmmr - 1600) / 100) * 100;
  } else if (mmmr < 2400) {
    mmmrTier = "Emerald";
    mmmrDivision = divisions[parseInt((mmmr - 2000) / 100)];
    mmmrLP = mmmr - 2000 - parseInt((mmmr - 2000) / 100) * 100;
  } else if (mmmr < 2800) {
    mmmrTier = "Diamond";
    mmmrDivision = divisions[parseInt((mmmr - 2400) / 100)];
    mmmrLP = mmmr - 2400 - parseInt((mmmr - 2400) / 100) * 100;
  } else if (mmmr < 3200) {
    mmmrTier = "Master";
    mmmrDivision = "";
    mmmrLP = mmmr - 2800;
  } else if (mmmr < 3600) {
    mmmrTier = "Grandmaster";
    mmmrDivision = "";
    mmmrLP = mmmr - 2800;
  } else {
    mmmrTier = "Challenger";
    mmmrDivision = "";
    mmmrLP = mmmr - 2800;
  }
  calc.mmmrTier = mmmrTier;
  calc.mmmrDivision = mmmrDivision;
  calc.mmmrLP = mmmrLP;
  const delta = parseInt(
    (Date.now() / 1000 - match.timestamp - match.duration) / 60
  );
  calc.time = "";
  if (delta === 1) {
    calc.time = "1 min ago";
  } else if (delta < 60) {
    calc.time = delta + " mins ago";
  } else if (delta < 120) {
    calc.time = "1 hour ago";
  } else if (delta < 60 * 24) {
    calc.time = parseInt(delta / 60) + " hours ago";
  } else if (delta < 60 * 24 * 2) {
    calc.time = "1 day ago";
  } else if (delta < 60 * 24 * 90) {
    calc.time = parseInt(delta / 60 / 24) + " days ago";
  } else calc.time = "months ago";
  calc.bots = profiles.botQueues.indexOf(match.queue) === -1 ? false : true;
  if (match.duration > 360 || calc.bots)
    calc.result = match.winner[pid] ? "victory" : "defeat";
  else calc.result = "remake";
  calc.queue =
    typeof queues[match.queue] !== "undefined"
      ? queues[match.queue]
      : "Unknown";
  calc.csMin = ((calc.totalMinions[pid] / match.duration) * 60).toFixed(1);
  return calc;
}

export default calcData;
